
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(isTireProduct, storePhone, isStoreSelected, isStaggeredProduct, isStaggeredEnabled, badge, badgeIndex) {
                    return [_createElement('span', {
                            'className': 'product-label product-label--convermax cm_badge cm_badge__' + this.toKebabCase(badge),
                            'key': '13791'
                        }, '\n              ', badge, '\n            ')];
                }
                function scopePercentageDiscountInitialPriceDiscountInitialPrice2(isTireProduct, storePhone, isStoreSelected, isStaggeredProduct, isStaggeredEnabled) {
                    var percentageDiscount = this.price * (this.percentage_discount || 0) / 100;
                    var initialPriceDiscount = percentageDiscount + (this.dollars_discount || 0) / 4;
                    var initialPrice = this.formatPrice(this.price - initialPriceDiscount);
                    return _createElement('div', {
                        'className': 'price titan-price',
                        'data-initial-price': initialPrice,
                        'data-initial-discount': initialPriceDiscount,
                        'data-regional-price': this.price,
                        'data-percentage-discount': percentageDiscount,
                        'data-dollars-discount': this.dollars_discount || 0,
                        'key': '35561'
                    }, _createElement('div', { 'className': 'titan-left-price' + (!isStaggeredEnabled && initialPriceDiscount > 0 ? ' titan-price-green' : '') }, _createElement('strong', { 'className': 'titan-price-amount' }, initialPrice), _createElement('span', { 'className': 'titan-price-amount-label' }, 'EA.')), _createElement('div', { 'className': 'titan-right-price' + (initialPriceDiscount > 0 ? '' : ' cm_hide') }, _createElement('span', { 'className': 'titan-price-amount' }, this.formatPrice(this.price)), _createElement('span', { 'className': 'titan-price-amount-label' }, 'EA.')));
                }
                function repeatSaving3(isTireProduct, storePhone, isStoreSelected, isStaggeredProduct, isStaggeredEnabled, saving, savingIndex) {
                    return _createElement('ul', {
                        'className': 'titan-info-list',
                        'key': saving
                    }, _createElement('li', { 'className': 'blueStar' }, saving));
                }
                function scopeIsTireProductStorePhoneIsStoreSelectedIsStaggeredProductIsStaggeredEnabled4() {
                    var isTireProduct = this.FitmentType?.includes('Tire');
                    var storePhone = window.Convermax.selectedStorePhone;
                    var isStoreSelected = window.Convermax.isStoreSelected;
                    var isStaggeredProduct = this._badges?.some(b => b === 'Front' || b === 'Rear');
                    var isStaggeredEnabled = window.Convermax.isOnStaggeredSearch() || isStaggeredProduct;
                    return _createElement('li', { 'className': 'w-full' }, _createElement('product-card', {
                        'id': 'titan-product-card-' + this.id,
                        'data-staggered': isStaggeredProduct,
                        'class': 'card card--product h-full relative flex flex-col md:flex-row items-center'
                    }, _createElement('div', { 'className': 'card__media flex flex-col' }, _createElement('div', { 'className': 'image-container' }, _createElement('a', {
                        'href': this.url,
                        'aria-label': this.removeHTML(this.title),
                        'tabIndex': '-1',
                        'className': 'block image-blend js-prod-link'
                    }, _createElement('img', {
                        'src': this.resizeImage(this.image || window.Convermax.getProductImage(this.FitmentType[0])),
                        'loading': 'lazy',
                        'alt': this.removeHTML(this.title),
                        'className': 'card__main-image no-js-hidden'
                    })), this.wheel_mpn ? _createElement('button', {
                        'className': 'cm_view-on-vehicle-btn btn cm_btn--secondary',
                        'onClick': () => window.Convermax.openVisualizationDialog(this.wheel_mpn),
                        'key': '1031'
                    }, '\n          See on your vehicle\n        ') : null), _createElement('div', { 'className': 'product-label-container absolute top-0 start' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'product-label-wrapper flex' },
                        _map(this._badges, repeatBadge1.bind(this, isTireProduct, storePhone, isStoreSelected, isStaggeredProduct, isStaggeredEnabled)),
                        this.custom_flag_text ? _createElement('span', {
                            'className': 'product-label product-label--convermax',
                            'key': '1613'
                        }, '\n            ', this.custom_flag_text, '\n          ') : null
                    ]))), _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full' }, _createElement('p', { 'className': 'card__vendor text-sm text-theme-light' }, this.removeHTML(this.Brand)), _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', {
                        'href': this.url,
                        'className': 'card-link text-current js-prod-link'
                    }, '\n              ', this.removeHTML(`${ this.etail_model ?? this.title }`), '\n            ')), !this.is_article ? [
                        _createElement('p', {
                            'className': 'card__size rte',
                            'key': '22951'
                        }, !isTireProduct ? [
                            '\n                ',
                            this.removeHTML(this.wheel_size),
                            '\n                ',
                            this.wheel_finish ? [
                                ' | ',
                                this.removeHTML(this.wheel_finish)
                            ] : null
                        ] : null, isTireProduct ? [
                            '\n                ',
                            this.removeHTML(this.tire_size),
                            '\n                ',
                            this.tire_load_index && this.tire_speed_rating ? [
                                '\n                  | ',
                                this.removeHTML(`${ this.tire_load_index }${ this.tire_speed_rating }`),
                                '\n                '
                            ] : null,
                            this.etail_warranty_distance ? [
                                _createElement('span', {
                                    'className': 'bullet',
                                    'key': '29451'
                                }, '\u2022'),
                                ' ',
                                this.etail_warranty_distance,
                                ' Mile Warranty\n                '
                            ] : null,
                            this.tire_tread_wear_grade && this.tire_traction_grade && this.tire_temperature_grade ? [
                                _createElement('span', {
                                    'className': 'bullet',
                                    'key': '31411'
                                }, ' \u2022'),
                                ' UTQG: ',
                                this.removeHTML(`${ this.tire_tread_wear_grade }
                  ${ this.tire_traction_grade } ${ this.tire_temperature_grade }`),
                                '\n                '
                            ] : null
                        ] : null),
                        isStoreSelected && this.price ? [
                            scopePercentageDiscountInitialPriceDiscountInitialPrice2.apply(this, [
                                isTireProduct,
                                storePhone,
                                isStoreSelected,
                                isStaggeredProduct,
                                isStaggeredEnabled
                            ]),
                            _createElement('p', {
                                'className': 'card__tax',
                                'key': '35563'
                            }, '\n                Tire Price does not include tax, installation, or\n                ', _createElement('span', { 'className': 'card__tax-savings' }, 'Bonus Savings \u2605'))
                        ] : null,
                        !isStoreSelected ? _createElement('div', {
                            'className': 'login-for-pricing',
                            'key': '22955'
                        }, _createElement('span', {}, '\n                Select store to view pricing.\n                ', _createElement('a', {
                            'href': '/pages/locations',
                            'className': 'store-locator-modal'
                        }, 'Change Store'))) : null,
                        _createElement('ul', {
                            'className': 'titan-info-list',
                            'key': '22957'
                        }, this.available_today ? _createElement('li', {
                            'className': 'titan-stock-info available',
                            'key': '5352'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '54370'
                            }, _createElement('circle', {
                                'cx': '8',
                                'cy': '8',
                                'r': '4'
                            }))], _createElement('strong', { 'className': 'titan-stock-info-status' }, '\n                  Available today at your ', window.Convermax.selectedStoreName, ' store\n                ')) : null, this.availability_date ? _createElement('li', {
                            'className': 'titan-stock-info backordered',
                            'key': '5788'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '58770'
                            }, _createElement('circle', {
                                'cx': '8',
                                'cy': '8',
                                'r': '4'
                            }))], _createElement('span', {}, _createElement('strong', { 'className': 'titan-stock-info-status' }, '\n                    Available ', this.availability_date, ' at the ', window.Convermax.selectedStoreName, ' store\n                  '), _createElement('a', {
                            'href': '/pages/locations',
                            'className': 'store-locator-modal'
                        }, ' Change Store'))) : null, this.call_for_availability ? _createElement('li', {
                            'className': 'titan-stock-info limited',
                            'key': '6392'
                        }, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '64810'
                            }, _createElement('circle', {
                                'cx': '8',
                                'cy': '8',
                                'r': '4'
                            }))], _createElement('strong', { 'className': 'titan-stock-info-status' }, ' Limited Stock'), storePhone ? [
                            '\n                  : Call store for availability ',
                            _createElement('a', {
                                'href': `tel:${ storePhone }`,
                                'key': '67261'
                            }, storePhone)
                        ] : null) : null, _createElement('li', {}, [_createElement('svg', {
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '69460'
                            }, _createElement('path', {
                                'd': 'M3.5 8.5L6.5 11.5L12.5 5.5',
                                'fill': 'none',
                                'stroke': 'green',
                                'strokeWidth': '2.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))], _createElement('strong', {}, 'Pay Monthly:'), ' Zero interest if paid in full within 6 months.\n                ', _createElement('a', {
                            'href': '/pages/credit-card',
                            'className': 'pay-montly-link',
                            'target': '_blank'
                        }, 'Learn More')))
                    ] : null), !this.is_article ? [
                        this.bonus_savings ? _createElement('div', {
                            'className': 'mt-2 mb-2 pdp-deals-block',
                            'key': '74721'
                        }, _createElement('hr', {}), _createElement.apply(this, [
                            'div',
                            { 'className': 'titan-deals-list' },
                            _createElement('span', {}, 'Buy Four and Unlock ', _createElement('span', { 'className': 'blue-text' }, 'Bonus Savings:')),
                            _map(this.bonus_savings, repeatSaving3.bind(this, isTireProduct, storePhone, isStoreSelected, isStaggeredProduct, isStaggeredEnabled))
                        ])) : null,
                        isStoreSelected ? _createElement('div', {
                            'className': 'card__quick-add mob:card__quick-add--below desktop:card__quick-add--below',
                            'key': '74723'
                        }, this.call_for_availability ? _createElement('div', { 'key': '8082' }, _createElement('a', {
                            'className': 'btn call-store-button btn--primary w-full',
                            'type': 'button',
                            'href': `tel:${ storePhone }`
                        }, _createElement('span', { 'className': 'quick-add-btn-text' }, 'CALL STORE ', storePhone))) : null, !this.call_for_availability ? _createElement('product-form', { 'key': '8370' }, _createElement('div', {
                            'className': 'alert mb-8 bg-error-bg text-error-text js-form-error text-start',
                            'role': 'alert',
                            'hidden': true
                        }), _createElement('form', {
                            'method': 'post',
                            'action': '/cart/add',
                            'id': 'quick-add-' + this.id,
                            'acceptCharset': 'UTF-8',
                            'className': 'js-product-form',
                            'encType': 'multipart/form-data',
                            'noValidate': true,
                            'data-product-id': this.id
                        }, _createElement('input', {
                            'type': 'hidden',
                            'name': 'form_type',
                            'value': 'product'
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'utf8',
                            'value': '\u2713'
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'product-id',
                            'value': this.id
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'id',
                            'value': this.variant_ids
                        }), _createElement('input', {
                            'type': 'hidden',
                            'name': 'quantity',
                            'value': isStaggeredEnabled ? 2 : 4
                        }), _createElement('div', { 'className': 'inline-block' }, _createElement('label', {
                            'className': 'label visually-hidden',
                            'htmlFor': 'quantity-template--' + this.id + '__main'
                        }, 'Qty'), _createElement('div', { 'className': 'qty-input qty-input--combined inline-flex items-center w-full' }, _createElement('button', {
                            'type': 'button',
                            'className': 'qty-input__btn btn btn--minus no-js-hidden',
                            'name': 'minus',
                            'onClick': e => window.Convermax.handleQtySelector(e.target, this.formatPrice)
                        }, _createElement('span', { 'className': 'visually-hidden' }, '-')), _createElement('input', {
                            'type': 'number',
                            'className': 'qty-input__input input',
                            'id': 'quantity-template--' + this.id + '__main',
                            'min': '1',
                            'max': '7',
                            'defaultValue': isStaggeredEnabled ? 2 : 4,
                            'name': 'quantity',
                            'disabled': true
                        }), _createElement('button', {
                            'type': 'button',
                            'className': 'qty-input__btn btn btn--plus no-js-hidden',
                            'name': 'plus',
                            'onClick': e => window.Convermax.handleQtySelector(e.target, this.formatPrice)
                        }, _createElement('span', { 'className': 'visually-hidden' }, '+')))), _createElement('button', {
                            'onClick': window.Convermax.addStaggeredPackagesToCart(this),
                            'className': 'btn add-to-cart-button btn--primary w-full',
                            'data-add-to-cart-text': 'Add to cart',
                            'name': 'add',
                            'aria-haspopup': 'dialog'
                        }, _createElement('span', { 'className': 'quick-add-btn-text' }, 'Add to cart')))) : null) : null
                    ] : null))));
                }
                return scopeIsTireProductStorePhoneIsStoreSelectedIsStaggeredProductIsStaggeredEnabled4.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'ul',
        { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []